import { adminRoutes } from './routes/admin';
import { auditRoutes } from './routes/audit';
import { financeRoutes } from './routes/finance';
import { financeVersionRoutes } from './routes/finance-version';
import { permissionRoutes } from './routes/permission';
import { consultationRoutes } from './routes/consultation';
import { consultationWorkspaceRoutes } from './routes/consultation-workspace';

/**
 * 側邊選單與動態路由的模組順序（與 SideMenu 共用）
 *
 * 選單分組與順序見 router/sideNav.js（全部／諮詢師／管理／工程師）。
 * 這裡只決定路由註冊順序。
 */
export const modulesConfig = [
    {
        folder: consultationWorkspaceRoutes[0],
        children: consultationWorkspaceRoutes[0].children
    },
    {
        folder: financeVersionRoutes[0],
        children: financeVersionRoutes[0].children
    },
    { folder: financeRoutes[0], children: financeRoutes[0].children },
    { folder: consultationRoutes[0], children: consultationRoutes[0].children },
    { folder: permissionRoutes[0], children: [] },
    { folder: adminRoutes[0], children: [] },
    { folder: auditRoutes[0], children: [] }
];
